/**
 * @file agencyPages.js
 * @description Guest views aimed at agencies. A header sign-up started on one of these is an
 *   agency sign-up (Agency preselected) and the header button reads "Post a case free".
 *   Shared by App.js (intent handling) and TopNav (label), so the two never drift.
 * @module lib/agencyPages
 */
export const AGENCY_PAGE_VIEWS = new Set([
  "aba-agencies",
  "post-aba-cases",
  "post-a-case",
  "aba-staffing-for-small-agencies",
  "aba-staffing-florida",
  "rbt-staffing-miami-fl",
  "rbt-staffing-charlotte-nc",
]);

export const isAgencyPageView = (view) => AGENCY_PAGE_VIEWS.has(view);
